export const simpleContractAddress = "0x185Eb02Bdd555A3920b40496FBEd13098E269BA0";
